import { ethers } from 'ethers';
import evm from '@wormhole-foundation/sdk/evm';
import solana from '@wormhole-foundation/sdk/solana';
import sui from '@wormhole-foundation/sdk/sui';
import { PublicKey } from '@solana/web3.js';
import { TokenTransfer, Wormhole, wormhole, } from '@wormhole-foundation/sdk';
import { ConnectorsError } from '../../services/errors/genius-error';
import { ConnectorsErrorCode } from '../../types/services/connectors-error';
import { WormholeTokens } from '../../utils/wormhole/WormholeTokens';
import { getAssociatedTokenAccount } from '../../utils/solana/base';
import { ChainId } from '../../utils/config/networks';
import { Bridge } from '../../types/services/enums';
import { deepConvertWormhole } from '../../utils/off-chain/deep-convert-bigint';
export class WormholeService {
    constructor() {
        this.name = Bridge.WORMHOLE;
        this.chains = [
            ChainId.BASE,
            ChainId.SOLANA,
            ChainId.ARBITRUM,
            ChainId.OPTIMISM,
            ChainId.POLYGON,
            ChainId.BSC,
            ChainId.AVALANCHE,
            ChainId.BLAST,
            ChainId.ETHEREUM,
            ChainId.SUI,
        ];
    }
    mapChainIdToWormholeChain(chainId) {
        switch (chainId) {
            case ChainId.BASE:
                return 'Base';
            case ChainId.SOLANA:
                return 'Solana';
            case ChainId.ARBITRUM:
                return 'Arbitrum';
            case ChainId.OPTIMISM:
                return 'Optimism';
            case ChainId.POLYGON:
                return 'Polygon';
            case ChainId.BSC:
                return 'Bsc';
            case ChainId.AVALANCHE:
                return 'Avalanche';
            case ChainId.BLAST:
                return 'Blast';
            case ChainId.ETHEREUM:
                return 'Ethereum';
            case ChainId.SUI:
                return 'Sui';
            default:
                return null;
        }
    }
    async verifyWormholeToken(networkIn, networkOut, tokenIn, tokenOut) {
        const wormholeToken = WormholeTokens.find((token) => {
            const tokenInMatch = token.chainTokens.some((chainToken) => {
                const addressMatch = chainToken.address.toLowerCase() === tokenIn.toLowerCase();
                const chainMatch = chainToken.chainId === networkIn;
                console.log(`Token ${token.symbol}:
          Comparing addresses: ${chainToken.address.toLowerCase()} === ${tokenIn.toLowerCase()}
          Address match: ${addressMatch} IN ${networkIn} CHAIN_TOKEN ${chainToken.chainId}
          Chain match: ${chainMatch}`);
                return addressMatch && chainMatch;
            });
            const networkOutMatch = token.chainTokens.some((chainToken) => {
                const match = chainToken.chainId === networkOut;
                console.log(`Checking network out: ${chainToken.chainId} === ${networkOut}: ${match}`);
                return match;
            });
            console.log(`Final result for ${token.symbol}: ${tokenInMatch && networkOutMatch}\n`);
            return tokenInMatch && networkOutMatch;
        });
        console.log(`WORMHOLE_TOKEN`, wormholeToken);
        if (!wormholeToken) {
            throw new ConnectorsError(ConnectorsErrorCode.WORMHOLE_TOKEN_NOT_FOUND, {
                connector: Bridge.WORMHOLE,
                tokenIn: tokenIn,
                tokenOut: tokenOut,
            });
        }
    }
    async prepareTransaction() {
        return ['123123']; // Placeholder
    }
    async fetchBridgeQuoteAndPrice(params) {
        await this.verifyWormholeToken(params.networkIn, params.networkOut, params.tokenIn, params.tokenOut);
        const { tokenTransfer, quoteTransfer } = await this.getWormholeTokenTransfer(params);
        const { price, quote } = this.preparePriceAndQuoteResponse(params, quoteTransfer);
        const transactions = {
            sponsor: null,
            allowance: null,
            preSwapAggregatorResponse: null,
            wormholeTokenTransfer: tokenTransfer,
        };
        const response = {
            bridge: Bridge.WORMHOLE,
            price,
            quote,
            transactions,
        };
        const deepConverted = deepConvertWormhole(response);
        return deepConverted;
    }
    async getWormholeTokenTransfer(params) {
        if (params.networkOut === ChainId.SOLANA) {
            const toPk = new PublicKey(params.to);
            const tokenOutPk = new PublicKey(params.tokenOut);
            const toAta = getAssociatedTokenAccount(toPk, tokenOutPk);
            params.to = toAta.toString();
            params.recipient = toAta.toString();
        }
        if (params.networkIn === ChainId.SOLANA) {
            const fromPk = new PublicKey(params.from);
            const tokenInPk = new PublicKey(params.tokenIn);
            const fromAta = getAssociatedTokenAccount(fromPk, tokenInPk);
            params.from = fromAta.toString();
        }
        const wh = await wormhole('Mainnet', [evm, solana, sui]);
        const srcChain = this.mapChainIdToWormholeChain(params.networkIn);
        const destChain = this.mapChainIdToWormholeChain(params.networkOut);
        const sendChain = wh.getChain(srcChain);
        const rcvChain = wh.getChain(destChain);
        const token = Wormhole.tokenId(sendChain.chain, params.tokenIn);
        const from = Wormhole.chainAddress(srcChain, params.from);
        const to = Wormhole.chainAddress(destChain, params.to);
        // Create a TokenTransfer object to track the state of the transfer over time
        console.log('satyam123. from address', from.address);
        console.log('satyam123. to address', to.address);
        const tokenTransfer = await wh.tokenTransfer(token, BigInt(params.amountIn), from, to, 
        // TODO: if we pass in true, we don't need to attest the transfer, or call the completeTransfer ourselves
        true, null, BigInt(0));
        console.log(`Fetched wormhole transfer`);
        let quoteTransfer;
        try {
            quoteTransfer = await TokenTransfer.quoteTransfer(wh, sendChain, rcvChain, tokenTransfer.transfer);
        }
        catch (e) {
            console.log(`THIS_IS_THE_ERROR`, e);
        }
        console.log('satyam123, tokenTransfer', tokenTransfer);
        console.log('satyam123, quoteTransfer', quoteTransfer);
        if (tokenTransfer.transfer.automatic && quoteTransfer.destinationToken.amount < 0) {
            throw new ConnectorsError(ConnectorsErrorCode.AMOUNT_REQUESTED_TOO_LOW, {
                connector: Bridge.WORMHOLE,
                amountIn: params.amountIn,
            });
        }
        return {
            tokenTransfer,
            quoteTransfer,
        };
    }
    preparePriceAndQuoteResponse(params, quoteTransfer) {
        const price = {
            bridge: Bridge.WORMHOLE,
            networkIn: params.networkIn,
            networkOut: params.networkOut,
            tokenIn: params.tokenIn,
            tokenOut: quoteTransfer.destinationToken.token.address.toString(),
            amountIn: params.amountIn,
            amountOut: quoteTransfer.destinationToken.amount.toString(),
            response: quoteTransfer,
        };
        const quote = {
            bridge: this.name,
            amountIn: params.amountIn,
            amountOut: quoteTransfer.destinationToken.amount.toString(),
            tokenIn: params.tokenIn,
            tokenOut: quoteTransfer.destinationToken.token.address.toString(),
            networkIn: params.networkIn,
            networkOut: params.networkOut,
            router: '',
            calldata: '',
            nativeValue: '0',
            isNativeSwap: false,
            gasEstimate: '0',
            gasLimit: '0',
            response: {
                slippage: params.slippage,
                from: params.from,
                to: params.to,
                orchestrator: params.orchestrator,
            },
        };
        return {
            price,
            quote,
        };
    }
}
async function testSolToSui() {
    const wh = await wormhole('Mainnet', [evm, solana, sui]);
    const orchestrator = {
        ethAddress: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
        tokenId: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
        publicKey: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
    };
    const params = {
        networkIn: ChainId.SOLANA,
        networkOut: ChainId.SUI,
        tokenIn: '7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs',
        tokenOut: '0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN',
        amountIn: '47422',
        slippage: 0.01,
        from: '3g3zYQ3Bkpwgyy3bo1LeeY9KT1tomiBZy9KbJW74XujD',
        recipient: '0xc5650701875190a0ce5ba3437995b2c4ef88e5cab4989956c6284eaf7e516dda',
        orchestrator,
        orchestrate: false,
        to: '0xc5650701875190a0ce5ba3437995b2c4ef88e5cab4989956c6284eaf7e516dda',
        tokenMetadata: [
            {
                address: '7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs',
                name: 'WETH',
                symbol: 'WETH',
                decimals: 9,
            },
        ],
    };
    const wormholeClass = new WormholeService();
    const resp = await wormholeClass.fetchBridgeQuoteAndPrice(params);
    console.log(`RESPONSE`, resp);
    // const conn = new Connection(
    //   'https://mainnet.helius-rpc.com/?api-key=8bab07d6-d614-478e-ba36-c2e07ea6d720'
    // );
    // const sln = await solana();
    // const signer1 = await sln.getSigner(
    //   conn,
    //   '5BMA1TD7tnfkjYJr3vFt7CJhB8PZoMDJ6Cc5Pv83HQDUtqJ2fBs3DCM5ooYdTu7JzwrHP8dWM6w4R7UnvjhsJL8w',
    //   {
    //     debug: true,
    //     priorityFee: {
    //       percentile: 0.75,
    //       percentileMultiple: 2,
    //       min: 200000,
    //       max: 3000000,
    //     },
    //   }
    // );
    // console.log('satyam123, signer1', signer1.address());
    // const txIds = await resp.transactions.wormholeTokenTransfer.initiateTransfer(signer1);
    // console.log('satyam123, txIds', txIds);
    // resp.transactions.wormholeTokenTransfer.getTransferState();
    // const receipt = await waitLog(wh, resp.transactions.wormholeTokenTransfer);
    // console.log('satyam123, receipt', receipt);
}
// async function testSuiToSol() {
//   const orchestrator: IExtendedRelayPKP = {
//     ethAddress: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
//     tokenId: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
//     publicKey: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
//   };
//   const params: BridgeQuoteParams = {
//     networkIn: ChainId.SUI,
//     networkOut: ChainId.SOLANA,
//     tokenIn: '0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN',
//     tokenOut: '7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs',
//     amountIn: '25176',
//     slippage: 0.01,
//     recipient: '3g3zYQ3Bkpwgyy3bo1LeeY9KT1tomiBZy9KbJW74XujD',
//     from: '0xc5650701875190a0ce5ba3437995b2c4ef88e5cab4989956c6284eaf7e516dda',
//     orchestrator,
//     orchestrate: false,
//     to: '3g3zYQ3Bkpwgyy3bo1LeeY9KT1tomiBZy9KbJW74XujD',
//     tokenMetadata: [
//       {
//         address: '7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs',
//         name: 'WETH',
//         symbol: 'WETH',
//         decimals: 9,
//       },
//     ],
//   };
//   const wormholeClass = new WormholeService();
//   const resp = await wormholeClass.fetchBridgeQuoteAndPrice(params);
//   const conn = new SuiClient({
//     url: 'https://sui-mainnet.blockvision.org/v1/2o4sVybXFInyr84XlR4U9aLpzP1',
//   });
//   const s = await sui();
//   // begin cube oblige spoon ability void tuna slight sketch upset chat blame
//   const signer1 = await s.getSigner(
//     conn,
//     'begin cube oblige spoon ability void tuna slight sketch upset chat blame'
//   );
//   console.log('satyam123, signer1', signer1.address());
//   const txIds = await resp.transactions.wormholeTokenTransfer.initiateTransfer(signer1);
//   console.log('satyam123, txIds', txIds);
// }
async function testEvmToSui() {
    const orchestrator = {
        ethAddress: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
        tokenId: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
        publicKey: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
    };
    const params = {
        networkIn: ChainId.ETHEREUM,
        networkOut: ChainId.SUI,
        tokenIn: '0xD8369C2EDA18dD6518eABb1F85BD60606dEb39Ec',
        tokenOut: '0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN',
        amountIn: '263975184432438',
        slippage: 0.01,
        from: '0x9ff3b12a6bb313a92395fa86e5d03dd8e3f9192b',
        recipient: '0xc5650701875190a0ce5ba3437995b2c4ef88e5cab4989956c6284eaf7e516dda',
        orchestrator,
        orchestrate: false,
        to: '0xc5650701875190a0ce5ba3437995b2c4ef88e5cab4989956c6284eaf7e516dda',
        tokenMetadata: [
            {
                address: '0xD8369C2EDA18dD6518eABb1F85BD60606dEb39Ec',
                name: 'WETH',
                symbol: 'WETH',
                decimals: 9,
            },
        ],
    };
    const wormholeClass = new WormholeService();
    const resp = await wormholeClass.fetchBridgeQuoteAndPrice(params);
    console.log(`RESPONSE_FROM_TEST`, resp);
    const conn = new ethers.providers.JsonRpcProvider('https://radial-distinguished-field.quiknode.pro/c78722d95d09a1e0b42f6cac7c3b732fa9a611d5/');
    const e = await evm();
    const signer1 = await e.getSigner(conn, '0x9fa7d1a5fe775c30633be46b0a161aa5b1e5b132c83bd00228f4c5eb554d773b', {
        debug: true,
        // maxGasLimit: BigInt(27615964838),
        // overrides is a Partial<TransactionRequest>, so any fields can be overriden
        overrides: {
            nonce: 25,
            maxFeePerGas: BigInt(11000000),
            maxPriorityFeePerGas: BigInt(200000),
        },
    });
    console.log('satyam123, signer1', signer1.address());
    const quoteResponse = resp.quote.response;
    const { tokenTransfer, quoteTransfer } = await wormholeClass.getWormholeTokenTransfer({
        networkIn: resp.quote.networkIn,
        networkOut: resp.quote.networkOut,
        tokenIn: resp.quote.tokenIn,
        tokenOut: resp.quote.tokenOut,
        slippage: quoteResponse.slippage,
        from: quoteResponse.from,
        recipient: quoteResponse.from,
        to: quoteResponse.to,
        amountIn: resp.quote.amountIn,
        orchestrate: false,
    });
    const txIds = await tokenTransfer.initiateTransfer(signer1);
    console.log('satyam123, txIds', txIds);
}
// async function testSuiToEvm() {
//   const orchestrator: IExtendedRelayPKP = {
//     ethAddress: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
//     tokenId: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
//     publicKey: '0x3d6807d5db47a2e3f70deb36d521ff1a3f47f951',
//   };
//   const params: BridgeQuoteParams = {
//     networkIn: ChainId.SUI,
//     networkOut: ChainId.OPTIMISM,
//     tokenIn: '0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN',
//     tokenOut: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
//     amountIn: '25176',
//     slippage: 0.01,
//     recipient: '0x9ff3b12a6bb313a92395fa86e5d03dd8e3f9192b',
//     from: '0xc5650701875190a0ce5ba3437995b2c4ef88e5cab4989956c6284eaf7e516dda',
//     orchestrator,
//     orchestrate: false,
//     to: '0x9ff3b12a6bb313a92395fa86e5d03dd8e3f9192b',
//     tokenMetadata: [
//       {
//         address: '0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN',
//         name: 'WETH',
//         symbol: 'WETH',
//         decimals: 9,
//       },
//     ],
//   };
//   const wormholeClass = new WormholeService();
//   const resp = await wormholeClass.fetchBridgeQuoteAndPrice(params);
//   const conn = new SuiClient({
//     url: 'https://sui-mainnet.blockvision.org/v1/2o4sVybXFInyr84XlR4U9aLpzP1',
//   });
//   const s = await sui();
//   // begin cube oblige spoon ability void tuna slight sketch upset chat blame
//   // suiprivkey1qqv32wg0uer2hpc70l9f5gut8483k3734wjqjgglxsngkxg5a05fk3vhayl
//   const signer1 = await s.getSigner(
//     conn,
//     'begin cube oblige spoon ability void tuna slight sketch upset chat blame'
//   );
//   console.log('satyam123, signer1', signer1.address());
//   const txIds = await resp.transactions.wormholeTokenTransfer.initiateTransfer(signer1);
//   console.log('satyam123, txIds', txIds);
// }
// export async function waitLog<N extends Network = Network>(
//   wh: Wormhole<N>,
//   xfer: TokenTransfer<N>,
//   tag: string = 'WaitLog',
//   timeout: number = DEFAULT_TASK_TIMEOUT
// ) {
//   const tracker = TokenTransfer.track(wh, TokenTransfer.getReceipt(xfer), timeout);
//   let receipt;
//   for await (receipt of tracker) {
//     console.log(`${tag}: Current trasfer state: `, TransferState[receipt.state]);
//   }
//   return receipt;
// }
// testSolToSui();
// // testSuiToSol();
// testEvmToSui();
// // testSuiToEvm();
